type AntdAppInstance = {
  message?: {
    error: (content: string) => void;
  };
  notification?: {
    error: (config: {
      message: string;
      description?: string;
      duration?: number;
    }) => void;
  };
};

let antdAppInstance: AntdAppInstance | null = null;

export const setAntdAppInstance = (instance: AntdAppInstance) => {
  antdAppInstance = instance;
};

export const getAntdMessage = () => {
  return antdAppInstance?.message;
};

export const getAntdNotification = () => {
  return antdAppInstance?.notification;
};
